module.exports = __webpack_public_path__ + "img/favicon.b8e50548.png";